<template>
  <div>
    <SingleRideHeader
      :presentedText="t('myTrips')"
    />

    <b-container class="py-5 after_page_header">
      <b-row>
        <b-col cols="12" md="12" class="pt-5">
          <div
            v-if="isUserManager"
            class="d-flex justify-content-between align-items-center">
            <div
              @click="addRideManualy()"
              class="friendly-action-btn"
            >
              {{ t('userRidesCreateShareRoute') }}
            </div>
            <div
              @click="goToAllMyRideManagerAtraction()"
              class="friendly-action-btn"
            >
              {{ t('userRidesAllMyActivities') }}
            </div>
            <div
              @click="goToEditProfile()"
              class="friendly-action-btn"
            >
              {{ t('userRidesEditProfile') }}
            </div>
          </div>
          <div 
            v-else
            class="d-flex justify-content-between align-items-center">
            <div @click="openRideInformationPage()" class="friendly-action-btn">
              {{ t('userRidesShareTripOnSite') }}
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>


  <b-container class="py-5 max-width_75_precent">
    <div class="categories-scroll">
      <div
        v-for="(category, key) in config.DEFAULT_CATEGORIES"
        :key="key"
        class="category-card"
        :title="t(category.descriptionKey)"
        :class="{ selected: selectedCategory === key }"
        @click="selectCategory(key)"
      >
        <div class="icon">{{ category.icon }}</div>
        <div class="title">
          {{ t(category.labelKey) }}
        </div>
      </div>
    </div>  
  </b-container>


    <b-container class="py-5 max-width_75_precent">
      <div class="ride-group-container">
        <!-- Desktop Table View -->
        <b-table
          :items="filteredUserRides"
          :fields="tableFields"
          responsive
          striped
          hover
          class="rides-table d-none d-md-table"
          :dir="isHebrew ? 'rtl' : 'ltr'"
          :empty-text="t('userRidesNoTrips')"
          primary-key="id"
        >
          <template #cell(title)="row">
            <div dir="rtl">
              <strong>{{ row.item.title }}</strong>
            </div>
          </template>

          <template #cell(text)="row">
            <div dir="rtl" class="ride-description" v-html="row.item.text"></div>
          </template>

          <template #cell(dates)="row">
            <div dir="rtl" class="d-flex align-items-center">
              <span>{{ row.item.start_date }} - {{ row.item.end_date }}</span>
            </div>
          </template>

          <template #cell(category)="row">
            <div dir="rtl" v-if="compareToUserId(row.item.authorId)">
              <b-form-select
                :key="`category-select-${row.item.id}`"
                :value="row.item.category_name || 'planning'"
                :options="categoryOptions"
                @change="internalUpdateRideCategory(row.item.id, $event)"
                size="sm"
                class="category-select"
              />
            </div>
            <div v-else dir="rtl">
              <span>{{ getCategoryLabel(row.item.category_name || 'planning') }}</span>
            </div>
          </template>

          <template #cell(actions)="row">
            <div dir="rtl">
              <div
                v-if="row.item.ride_manager_id"
                @click="goToRide(row.item.id)"
                class="friendly-action-link"
              >
                {{ t('userRidesViewPrivateTrip') }}
              </div>
              <div
                v-else
                @click="goToRide(row.item.id)"
                class="friendly-action-link"
              >
                {{ t('userRidesViewAndEditTrip') }}
              </div>
            </div>
          </template>
        </b-table>

        <!-- Mobile Card View -->
        <div class="d-md-none mobile-rides-container">
          <div
            v-for="userRide in filteredUserRides"
            :key="userRide.id"
            class="mobile-ride-card"
          >
            <div :dir="isHebrew ? 'rtl' : 'ltr'" class="mobile-ride-content">
              <div class="mobile-ride-header">
                <h5 class="mb-2">{{ userRide.title }}</h5>
              </div>
              
              <div class="mobile-ride-description mb-3" v-html="userRide.text"></div>
              
              <div class="mobile-ride-dates mb-3 d-flex align-items-center">
                <span>{{ userRide.start_date }} - {{ userRide.end_date }}</span>
              </div>
              
              <div class="mobile-ride-category mb-3" v-if="compareToUserId(userRide.authorId)">
                <label class="d-block mb-2" style="font-weight: 500;">{{ t('userRidesBelongsToCategoryLabel') }}</label>
                <b-form-select
                  :key="`category-select-mobile-${userRide.id}`"
                  :value="userRide.category_name || 'planning'"
                  :options="categoryOptions"
                  @change="internalUpdateRideCategory(userRide.id, $event)"
                  class="w-100"
                />
              </div>
              <div class="mobile-ride-category mb-3" v-else>
                <label class="d-block mb-2" style="font-weight: 500;">{{ t('userRidesCategoryLabel') }}</label>
                <span>{{ getCategoryLabel(userRide.category_name || 'planning') }}</span>
              </div>
              
              <div class="mobile-ride-actions">
                <div
                  v-if="userRide.ride_manager_id"
                  @click="goToRide(userRide.id)"
                  class="friendly-action-link mobile-friendly-action"
                >
                  {{ t('userRidesViewPrivateTrip') }}
                </div>
                <div
                  v-else
                  @click="goToRide(userRide.id)"
                  class="friendly-action-link mobile-friendly-action"
                >
                  {{ t('userRidesViewAndEditTrip') }}
                </div>
              </div>
            </div>
          </div>
          
          <div v-if="filteredUserRides.length === 0" class="text-center py-5" dir="rtl">
            <p>{{ t('userRidesNoTrips') }}</p>
          </div>
        </div>
      </div>
    </b-container>

    <b-modal
      id="createRideChoicesModal"
      v-model="showCreateRideChoices"
      size="lg"
      centered
      hide-header
      hide-footer
      content-class="create-ride-choices-modal-content"
      body-class="create-ride-choices-modal-body"
    >
      <div :dir="isHebrew ? 'rtl' : 'ltr'">
        <div class="create-ride-choices-modal-header">
          <h3 class="create-ride-choices-modal-title">{{ t('userRidesCreateChoiceTitle') }}</h3>
          <button
            type="button"
            class="create-ride-choices-modal-close"
            :aria-label="t('close')"
            @click="showCreateRideChoices = false"
          >
            <i class="fa-solid fa-xmark" aria-hidden="true"></i>
          </button>
        </div>
        <CreateRideChoices @choose="goToCreateRide" />
      </div>
    </b-modal>
  </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex';
import SingleRideHeader from "@/components/SingleRideHeader";
import CreateRideChoices from "@/components/CreateRideChoices.vue";
import config from '@/common/config';
import { translationMixin } from "@/mixins/translationMixin";

export default {
  name: 'UserRidesV',
  mixins: [translationMixin],
  computed: { ...mapGetters([ 'userRides',
                              'isAppLoggedIn',
                              'userId',
                              'isUserManager',
                              'compareToUserId',
                              ]),
      categoryOptions() {
        return Object.entries(this.config.DEFAULT_CATEGORIES).map(([value, obj]) => ({
          value,
          text: this.t(obj.labelKey)
        }));
      },
      tableFields() {
        const alignClass = this.isHebrew ? 'text-right' : 'text-left';
        return [
          {
            key: 'title',
            label: this.t('userRidesTableTitle'),
            thClass: alignClass,
            tdClass: alignClass
          },
          {
            key: 'text',
            label: this.t('userRidesTableDescription'),
            thClass: alignClass,
            tdClass: alignClass
          },
          {
            key: 'dates',
            label: this.t('userRidesTableDates'),
            thClass: alignClass,
            tdClass: alignClass
          },
          {
            key: 'category',
            label: this.t('userRidesTableCategory'),
            thClass: alignClass,
            tdClass: alignClass
          },
          {
            key: 'actions',
            label: this.t('userRidesTableActions'),
            thClass: alignClass,
            tdClass: alignClass
          }
        ];
      },
  },

  components: {
    SingleRideHeader,
    CreateRideChoices,

  },
    methods: { ...mapActions([  'fetchUserRides',
                                'removeAttractionFromRide',
                                'validateAndupdateAppToken',
                                'openRideInformationPage',
                                'goToAllMyRideManagerAtraction',
                                'updateRideCategory',
                                'showModal',
                                'checkUpdatedTermsForManager',
                              ]),
    goToEditProfile() {
      this.$router.push('/edit_profile');
    },
    filterRidesByCategory() {
           
      this.filteredUserRides = this.userRides.filter(ride => {
        const category = ride.category_name || 'planning';
        return category === this.selectedCategory;
      });
    },

    async internalUpdateRideCategory(rideId, newCategory) {
      this.showModal("loadingIcon");
      try {
        const rideCategoryInformation =  {'rideId':rideId, 'newCategory': newCategory}
        await this.updateRideCategory(rideCategoryInformation)
        await this.fetchUserRides();
      } finally {
        this.showModal("");
      }
    },
    addRideManualy( ){
      this.showCreateRideChoices = true;
    },
    // Not the first ride, so no from_start: it ends on the ride page, not onboarding.
    goToCreateRide( path ){
      this.showCreateRideChoices = false;
      this.$router.push( path );
    },

    curentuserIsTheRideAuthor( attractionAuthorId ){
      if( this.userId == attractionAuthorId ){
        return true;
        }
      return false
    },

    goToRide( rideId ) {
      this.$router.push('/single_ride_with_map/' + rideId )
    },

    selectCategory(key) {
      this.selectedCategory = key;
      this.filterRidesByCategory();
      this.$emit("category-selected", key);
    },

    getCategoryLabel(categoryKey) {
      const category = this.config.DEFAULT_CATEGORIES[categoryKey];
      return category ? this.t(category.labelKey) : categoryKey;
    }
  },
  
  watch: {
    userRides() {
      this.filterRidesByCategory();
    }
  },
  
  async created() {
    this.validateAndupdateAppToken();
    this.showModal("loadingIcon");
    try {
      await this.fetchUserRides();
    } finally {
      this.showModal("");
    }
    // Ride managers who have not signed the current agreement get the updated-terms
    // popup once per browser session (after the loading icon, which it would otherwise close).
    this.checkUpdatedTermsForManager();
  },
  mounted() {
    localStorage.removeItem('onboardingActive');
  },
  metaInfo() {
    return {
      title: 'TripPlanner',
      meta: [
        { property: 'og:title', content: 'TripPlanner' },
        { property: 'og:description', content: this.t('userRidesOgDescription') },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: 'https://tripplanner.co.il/user_rides' },
        { property: 'og:image', content: 'https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fphone_display_app.png?alt=media&token=ccfc9989-224e-40be-ae57-aa6ed4db8637' },
        { name: 'description', content: this.t('userRidesMetaDescription') }
      ],
      link: [
        { rel: 'canonical', href: 'https://tripplanner.co.il/user_rides' }
      ]
    };
  },
  data() {
    return {
      config: config.config,
      selectedCategory: 'planning',
      showCreateRideChoices: false,
      filteredUserRides: [],
    };
  },

};
</script>

<style>
/* b-modal renders outside this component, so scoped styles can't reach it. */
/* bootstrap-vue.css isn't loaded, so its backdrop would be solid black. */
#createRideChoicesModal___BV_modal_outer_ .modal-backdrop {
  opacity: 0.5;
}

.create-ride-choices-modal-content {
  border: 0;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(6, 53, 66, 0.25);
}

.create-ride-choices-modal-body {
  padding: 1.75rem 1.75rem 2.25rem;
  background:
    radial-gradient(circle at 12% 20%, rgba(52, 208, 182, 0.12), transparent 45%),
    radial-gradient(circle at 88% 80%, rgba(7, 160, 195, 0.1), transparent 45%),
    #f6fcfd;
}

.create-ride-choices-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.75rem;
}

.create-ride-choices-modal-title {
  margin: 0;
  font-size: 2.4rem;
  font-weight: 800;
  background: linear-gradient(135deg, #34D0B6, #07A0C3);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.create-ride-choices-modal-close {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  border: 0;
  border-radius: 50%;
  background: white;
  color: #4a5a60;
  font-size: 1.8rem;
  box-shadow: 0 4px 12px rgba(7, 160, 195, 0.15);
  cursor: pointer;
}

.create-ride-choices-modal-close:hover {
  color: #07a0c3;
}
</style>

<style scoped>

.after_page_header{
  margin-top: 0;
}

.max-width_75_precent{
  max-width: 75vw!important;
}





.ride-group-container {
  border: 2px solid #ddd;
  border-radius: 12px;
  background-color: rgba(7, 160, 195, 0.1);
  padding: 24px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

.categories-scroll {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 12px;
  padding: 12px 0;
  scrollbar-width: thin;
  scrollbar-color: #ccc transparent;
}

.category-card {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  background-color: #f7f7f7;
  border-radius: 12px;
  padding: 10px 16px;
  cursor: default;
  transition: background-color 0.2s ease;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}
.category-card:hover {
  background-color: #eaeaea;
}

.icon {
  font-size: 1.6rem;
  margin-inline-end: 12px; /* space between icon and text (both directions) */
  display: flex;
  align-items: center;
  justify-content: center;
}

.title {
  font-weight: 500;
  font-size: 1.2rem;
  line-height: 1.4;
  display: flex;
  align-items: center;
}

.category-card.selected {
  background-color: #dceeff;
  border: 1px solid #3399ff;
}

.rides-table {
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  font-size: 16px;
}

.rides-table ::v-deep thead th {
  background-color: rgba(7, 160, 195, 0.1);
  font-weight: 600;
  font-size: 16px;
  border-bottom: 2px solid #ddd;
  padding: 16px;
}

.rides-table ::v-deep tbody td {
  padding: 16px;
  vertical-align: middle;
  font-size: 16px;
}

.rides-table ::v-deep tbody tr:hover {
  background-color: rgba(7, 160, 195, 0.05);
}

.ride-description {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 16px;
}

.category-select {
  min-width: 150px;
}

[dir="ltr"] .category-select,
[dir="ltr"] .mobile-ride-category select {
  text-align: left;
  direction: ltr;
}

[dir="ltr"] .mobile-ride-category {
  text-align: left;
}

[dir="rtl"] .mobile-ride-category {
  text-align: right;
}

[dir="ltr"] .mobile-ride-header h5 {
  text-align: left;
}

[dir="ltr"] .mobile-ride-description {
  text-align: left;
  direction: ltr;
}

@media (max-width: 768px) {
  .rides-table ::v-deep table {
    font-size: 0.875rem;
  }
  
  .rides-table ::v-deep thead th,
  .rides-table ::v-deep tbody td {
    padding: 8px;
  }
  
  .ride-description {
    max-width: 150px;
  }
}

/* Mobile Card Styles */
.mobile-rides-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.mobile-ride-card {
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
  transition: box-shadow 0.2s ease;
}

.mobile-ride-card:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.mobile-ride-content {
  width: 100%;
}

.mobile-ride-header h5 {
  color: #333;
  font-weight: 600;
  margin-bottom: 12px;
}

.mobile-ride-description {
  color: #666;
  line-height: 1.6;
  max-height: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 1.1rem;
}

.mobile-ride-dates {
  color: #555;
  font-size: 1.05rem;
}

.mobile-ride-category {
  padding-top: 12px;
  border-top: 1px solid #eee;
}

.mobile-ride-actions {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #eee;
}

/* Friendly Action Buttons/Links */
.friendly-action-btn {
  background: linear-gradient(135deg, #4A90E2 0%, #357ABD 100%);
  color: white;
  padding: 14px 28px;
  border-radius: 25px;
  cursor: pointer;
  font-size: 1.3rem;
  font-weight: 600;
  text-align: center;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);
  border: none;
  display: inline-block;
}

.friendly-action-btn:hover {
  background: linear-gradient(135deg, #5BA0F2 0%, #468ACD 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(74, 144, 226, 0.4);
  color: white;
  text-decoration: none;
}

.friendly-action-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(74, 144, 226, 0.3);
}

.friendly-action-link {
  background: linear-gradient(135deg, #4A90E2 0%, #357ABD 100%);
  color: white;
  padding: 10px 20px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  text-align: center;
  transition: all 0.3s ease;
  box-shadow: 0 3px 10px rgba(74, 144, 226, 0.25);
  border: none;
  display: inline-block;
}

.friendly-action-link:hover {
  background: linear-gradient(135deg, #5BA0F2 0%, #468ACD 100%);
  transform: translateY(-2px);
  box-shadow: 0 5px 14px rgba(74, 144, 226, 0.35);
  color: white;
  text-decoration: none;
}

.friendly-action-link:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(74, 144, 226, 0.25);
}

.mobile-friendly-action {
  width: 100%;
  padding: 14px 20px;
  font-size: 1.05rem;
}

</style>